import { couponsConstants } from '@constants/coupons';

const initialState = {
    data: [],
    dataAll: [],
    loading: true,
    totalCount: 0,
    pages: 1,
};

export function coupons(state = initialState, action) {
    switch (action.type) {
        case couponsConstants.COUPONS_FETCH:
            return { ...state, loading: true };
        case couponsConstants.COUPONS_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.data.items,
                totalCount: action.data.totalCount,
                pages: action.data.pages,
            };
        case couponsConstants.COUPONS_SUCCESS_ALL:
            return { ...state, dataAll: action.data, loading: false };
        case couponsConstants.COUPONS_ERROR:
            return { ...state, data: [], loading: false };
        case couponsConstants.COUPONS_SET_COUPONS:
            return { ...state, data: action.data };
        case couponsConstants.COUPONS_UPDATE_STATUS:
            return {
                ...state,
                data: state.data.map(coupon =>
                    coupon.id === action.id ? { ...coupon, status: action.status } : coupon,
                ),
            };
        case couponsConstants.COUPONS_RESET_ALL:
            return { ...state, dataAll: [] };
        default:
            return state;
    }
}
